<template>
  <transition @enter="enter" @leave="leave" appear :css="false">
    <button
      class="circular-button"
      :class="{ 'circular-button--app' : $inApp, 'circular-button--pause' : $store.state.mode === 'playing' }"
      :key="$store.state.mode === 'playing'"
      @click="togglePlay"
    >
      <span class="circular-button__bg" />
      <img
        v-if="$store.state.mode === 'playing'"
        class="circular-button__icon"
        src="/assets/svg/pause.svg"
        alt="Pause game icon"
        data-icon
      >
      <img
        v-else
        class="circular-button__icon"
        :src="`/assets/svg/${isSoundPlaying ? 'play' : 'pause'}-audio.svg`"
        :alt="isSoundPlaying ? 'Sound playing icon' : 'Sound paused icon'"
        data-icon
      >
    </button>
  </transition>
</template>

<script>
import { init, enter, leave } from '@/scripts/animations';
// import audio from '@/scripts/audio';

export default {
  name: 'ButtonCircular',

  data() {
    return {
      isSoundPlaying: true,
    };
  },

  methods: {
    togglePlay() {
      let event;

      // audio.play('click');

      if (this.$store.state.mode === 'playing') {
        event = this.$store.state.mode === 'playing' ? 'pause' : 'resume';
      } else {
        this.isSoundPlaying = !this.isSoundPlaying;
        event = this.isSoundPlaying ? 'mute' : 'unmute';
      }

      this.$eventHub.$emit(event);
    },
    enter(el, done) {
      init.get('buttonCircular')(el);
      enter.get('buttonCircular')(el).then(done);
    },
    leave(el, done) {
      leave.get('buttonCircular')(el).then(done);
    },
  },
};
</script>

<style lang="scss" scoped>
.circular-button {
  position: absolute;
  top: 20px;
  left: 20px;
  padding: 8px;

  border-radius: 50%;
  cursor: pointer;
  pointer-events: auto;

  &.circular-button--app {
    top: 52px;
  }

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-color: $color-ui;
    border-radius: 50%;
    box-shadow: $button-shadow-small;

    @extend %grain;
  }

  &__icon {
    display: block;
    position: relative;
    width: 14px;
  }

  &.circular-button--app {
    padding: 6px;

    .circular-button__icon {
      width: 15px;
    }
  }

  @include mq(ipadP) {
    top: 30px;
    left: 30px;
    padding: 10px;

    &__icon {
      width: 16px;
    }

    &.circular-button--app {
      padding: 8px;

      .circular-button__icon {
        width: 20px;
      }
    }
  }

  @include mq(dm) {
    top: 40px;
    left: 40px;
    padding: 12px;

    &__icon {
      width: 24px;
    }

    &.circular-button--app {
      padding: 10px;

      .circular-button__icon {
        width: 28px;
      }
    }
  }

  @include mq($and: $is-not-touch-device) {
    &__bg {
      transition: transform 0.5s $flap;
    }
    &:hover &__bg {
      transform: scale(1.1);
    }
  }
}
</style>
